import React from 'react';
import { IonCardTitle, IonCardContent, IonLabel } from '@ionic/react';

type Props = {
  addresses: [],
  title: string,
};

const Address: React.FC<Props> = ({ addresses, title }) => {
  return (
    <div>
      <IonCardContent>
        <IonCardTitle>{title}</IonCardTitle>
        { addresses.map((item: any, index: number) => {
            const addressFormatted = `${item.line1} ${item.line2}, ${item.city} ${item.postalCode}`
            return (
              <div key={'address-' + index}>
                <div>{item.type}:</div>
                <div>
                  <IonLabel>
                    <a href={`http://maps.google.com/?q=${addressFormatted}`}>{addressFormatted}</a>
                  </IonLabel>
                </div>
              </div>
            );
          })
        }
      </IonCardContent>
    </div>
  )
  
};

export default Address;